import React, { useEffect, useState, useRef } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
// import Collapse from "@mui/material/Collapse";
// import IconButton from "@mui/material/IconButton";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase-config";
import { Typography, Button, Stack } from "@mui/material";
// import { useReactToPrint } from "react-to-print";
// import { useDownloadExcel } from "react-export-table-to-excel";
import * as XLSX from "xlsx";
import InsuranceIncomeStatementTableBody from "./InsuranceIncomeStatementTableBody";

function Row(props) {
  // const { data, total, name } = props;
  const { total, name, currency } = props;
  // const [open, setOpen] = React.useState(true);
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        {/* <TableCell>
          {data !== undefined ? (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          ) : null}
        </TableCell> */}
        <TableCell component="th" scope="row">
          {name}
        </TableCell>
        <TableCell align="right">
          {currency}. {total.toLocaleString()}
        </TableCell>
      </TableRow>
      {/* {data !== undefined ? (
        <TableRow>
          <TableCell
            style={{
              paddingBottom: 0,
              paddingTop: 0,
              paddingRight: 0,
              paddingLeft: 0,
            }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ marginLeft: 0 }}>
                <Table size="medium" aria-label="purchases">
                  <TableBody>
                    {Object.keys(data).map((key) => {
                      return (
                        <TableRow>
                          <TableCell align="center">{key}</TableCell>
                          <TableCell align="right">
                            Ksh. {data[key].toLocaleString()}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      ) : null} */}
    </React.Fragment>
  );
}

export default function IncomeStatement({
  id,
  year,
  period,
  company_name,
  periodIndex,
}) {
  const [dataId, setDataId] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const componentRef = useRef();
  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current,
  // });

  const tableRef = useRef(null);

  /* Callback invoked when the button is clicked */
  const xport = React.useCallback(async () => {
    /* Create worksheet from HTML DOM TABLE */
    // const table = document.getElementById("Table2XLSX");
    const table = tableRef.current;
    const wb = XLSX.utils.table_to_book(table);

    /* Export to file (start a download) */
    XLSX.writeFile(
      wb,
      `Income Statement ${company_name} ${period} ${year}.xlsx`
    );
  }, [company_name, period, year]);

  async function getIncomeStatement({ id, year, period, periodIndex }) {
    setLoading(true);
    const q = query(
      collection(db, "companies-financials"),
      where("company-id", "==", id),
      where("year", "==", year),
      where("type", "==", "Income Statement"),
      where("period", "==", period),
      where("period-index", "==", periodIndex)
    );
    let idDoc;
    const allDocs = [];
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      allDocs.push(doc.data());
      idDoc = doc.id;
    });
    setData(allDocs[0]);
    setDataId(idDoc);
    setLoading(false);
  }

  useEffect(() => {
    getIncomeStatement({ id, year, period, periodIndex });
  }, [id, period, year, periodIndex]);

  return loading ? (
    <h1>Loading</h1>
  ) : data === undefined ? (
    <Typography>No Data Available</Typography>
  ) : (
    <>
      {/* <Button variant="contained" onClick={handlePrint}>
        Print
      </Button> */}

      {!process.env.NODE_ENV || process.env.NODE_ENV === "development" ? (
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <Typography>{dataId}</Typography>
        </Stack>
      ) : (
        <></>
      )}

      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="flex-start"
        spacing={2}
      >
        <Button
          variant="outlined"
          onClick={xport}
          size="small"
          color="secondary"
        >
          Export to Excel
        </Button>
      </Stack>

      <Box
        sx={{
          marginBottom: "10px",
        }}
      />
      <TableContainer component={Paper} ref={componentRef}>
        <Table aria-label="income statement table" ref={tableRef}>
          <TableHead
            sx={{
              backgroundColor: "black",
            }}
          >
            <TableRow>
              {/* <TableCell /> */}
              <TableCell>Breakdown</TableCell>
              <TableCell align="right">{year}</TableCell>
            </TableRow>
          </TableHead>
          {data["insurance_company"] !== undefined ? (
            data["insurance_company"] === true ? (
              <InsuranceIncomeStatementTableBody data={data} />
            ) : (
              <></>
            )
          ) : (
            <TableBody>
              {data["Interest Income"] !== undefined ? (
                <Row
                  name="Interest Income"
                  key="Interest Income"
                  total={data["Interest Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Interest Expenses(Bank)"] !== undefined ? (
                <Row
                  name="Interest Expenses"
                  key="Interest Expenses"
                  total={data["Interest Expenses(Bank)"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Net Interest Income"] !== undefined ? (
                <Row
                  name="Net Interest Income"
                  key="Net Interest Income"
                  total={data["Net Interest Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Fee And Commission Income"] !== undefined ? (
                <Row
                  name="Fee And Commission Income"
                  key="Fee And Commission Income"
                  total={data["Fee And Commission Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Fee And Commission Expense"] !== undefined ? (
                <Row
                  name="Fee And Commission Expense"
                  key="Fee And Commission Expense"
                  total={data["Fee And Commission Expense"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Net Fee And Commission Income"] !== undefined ? (
                <Row
                  name="Net Fee And Commission Income"
                  key="Net Fee And Commission Income"
                  total={data["Net Fee And Commission Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Non Interest Income"] !== undefined ? (
                <Row
                  name="Non Interest Income"
                  key="Non Interest Income"
                  total={data["Non Interest Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Total Revenue"] !== undefined ? (
                <Row
                  name="Total Revenue"
                  key="Total Revenue"
                  total={data["Total Revenue"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Credit Impairment Losses(Bank)"] !== undefined ? (
                <Row
                  name="Credit Impairment Losses"
                  key="Credit Impairment Losses(Bank)"
                  total={data["Credit Impairment Losses(Bank)"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Operating Income"] !== undefined ? (
                <Row
                  name="Operating Income"
                  key="Operating Income"
                  total={data["Operating Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Cost of Goods Sold"] !== undefined ? (
                <Row
                  name="Cost of Goods Sold"
                  key="Cost of Goods Sold"
                  total={data["Cost of Goods Sold"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Reimbursable Expenses"] !== undefined ? (
                <Row
                  name="Reimbursable Expenses"
                  key="Reimbursable Expenses"
                  total={data["Reimbursable Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Revenue Less Reimbursable Expenses"] !== undefined ? (
                <Row
                  name="Revenue Less Reimbursable Expenses"
                  key="Revenue Less Reimbursable Expenses"
                  total={data["Revenue Less Reimbursable Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Gross Profit"] !== undefined ? (
                <Row
                  name="Gross Profit"
                  key="Gross Profit"
                  total={data["Gross Profit"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Other Income"] !== undefined ? (
                <Row
                  name="Other Income"
                  key="Other Income"
                  total={data["Other Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Total Income"] !== undefined ? (
                <Row
                  name="Total Income"
                  key="Total Income"
                  total={data["Total Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Net Foreign Exchange Income"] !== undefined ? (
                <Row
                  name="Net Foreign Exchange Income"
                  key="Net Foreign Exchange Income"
                  total={data["Net Foreign Exchange Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Factory Expenses"] !== undefined ? (
                <Row
                  name="Factory Expenses"
                  key="Factory Expenses"
                  total={data["Factory Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Other Losses/Gains-Net"] !== undefined ? (
                <Row
                  name="Other Losses/Gains-Net"
                  key="Other Losses/Gains-Net"
                  total={data["Other Losses/Gains-Net"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Employee Expenses"] !== undefined ? (
                <Row
                  name="Employee Expenses"
                  key="Employee Expenses"
                  total={data["Employee Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Loss On Valuation Of Shares"] !== undefined ? (
                <Row
                  name="Loss On Valuation Of Shares"
                  key="Loss On Valuation Of Shares"
                  total={data["Loss On Valuation Of Shares"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Gain/Loss On Valuation Of Shares"] !== undefined ? (
                <Row
                  name="Gain/Loss On Valuation Of Shares"
                  key="Gain/Loss On Valuation Of Shares"
                  total={data["Gain/Loss On Valuation Of Shares"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Repair And Maintenance Expenses"] !== undefined ? (
                <Row
                  name="Repair And Maintenance Expenses"
                  key="Repair And Maintenance Expenses"
                  total={data["Repair And Maintenance Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Distribution Costs"] !== undefined ? (
                <Row
                  name="Distribution Costs"
                  key="Distribution Costs"
                  total={data["Distribution Costs"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Administrative Expenses"] !== undefined ? (
                <Row
                  name="Administrative Expenses"
                  key="Administrative Expenses"
                  total={data["Administrative Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Foreign Exchange Losses"] !== undefined ? (
                <Row
                  name="Foreign Exchange Losses"
                  key="Foreign Exchange Losses"
                  total={data["Foreign Exchange Losses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Foreign Exchange Gains/Losses"] !== undefined ? (
                <Row
                  name="Foreign Exchange Gains/Losses"
                  key="Foreign Exchange Gains/Losses"
                  total={data["Foreign Exchange Gains/Losses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Increase In Expected Credit Losses"] !== undefined ? (
                <Row
                  name="Increase In Expected Credit Losses"
                  key="Increase In Expected Credit Losses"
                  total={data["Increase In Expected Credit Losses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Selling & Distribution Expenses"] !== undefined ? (
                <Row
                  name="Selling & Distribution Expenses"
                  key="Selling & Distribution Expenses"
                  total={data["Selling & Distribution Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Establishment Expenses"] !== undefined ? (
                <Row
                  name="Establishment Expenses"
                  key="Establishment Expenses"
                  total={data["Establishment Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Net Impairment Losses On Financial Assets"] !==
                undefined ? (
                <Row
                  name="Net Impairment Losses On Financial Assets"
                  key="Net Impairment Losses On Financial Assets"
                  total={data["Net Impairment Losses On Financial Assets"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Impairment Provision On Financial Assets"] !==
                undefined ? (
                <Row
                  name="Impairment Provision On Financial Assets"
                  key="Impairment Provision On Financial Assets"
                  total={data["Impairment Provision On Financial Assets"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Other Expenses"] !== undefined ? (
                <Row
                  name="Other Expenses"
                  key="Other Expenses"
                  total={data["Other Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Operating Expenses"] !== undefined ? (
                <Row
                  name="Operating Expenses"
                  key="Operating Expenses"
                  total={data["Operating Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Steam Costs"] !== undefined ? (
                <Row
                  name="Steam Costs"
                  key="Steam Costs"
                  total={data["Steam Costs"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data[
                "Increase/Decrease In Fair Value Of Investment Property"
              ] !== undefined ? (
                <Row
                  name="Increase/Decrease In Fair Value Of Investment Property"
                  key="Increase/Decrease In Fair Value Of Investment Property"
                  total={
                    data[
                    "Increase/Decrease In Fair Value Of Investment Property"
                    ]
                  }
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Share Of Loss/Profit In Joint Ventures"] !== undefined ? (
                <Row
                  name="Share Of Loss/Profit In Joint Ventures"
                  key="Share Of Loss/Profit In Joint Ventures"
                  total={data["Share Of Loss/Profit In Joint Ventures"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data[
                "Impairment Writeback/Loss On Trade Receivables And Contract Assets"
              ] !== undefined ? (
                <Row
                  name="Impairment Writeback/Loss On Trade Receivables And Contract Assets"
                  key="Impairment Writeback/Loss On Trade Receivables And Contract Assets"
                  total={
                    data[
                    "Impairment Writeback/Loss On Trade Receivables And Contract Assets"
                    ]
                  }
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Depreciation On Right Of Use Asset"] !== undefined ? (
                <Row
                  name="Depreciation On Right Of Use Asset"
                  key="Depreciation On Right Of Use Asset"
                  total={data["Depreciation On Right Of Use Asset"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Depreciation & Amortization"] !== undefined ? (
                <Row
                  name="Depreciation & Amortization"
                  key="Depreciation & Amortization"
                  total={data["Depreciation & Amortization"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Amortisation And Write Off Of Intangible Assets"] !==
                undefined ? (
                <Row
                  name="Amortisation And Write Off Of Intangible Assets"
                  key="Amortisation And Write Off Of Intangible Assets"
                  total={
                    data["Amortisation And Write Off Of Intangible Assets"]
                  }
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Other Operating Gains"] !== undefined ? (
                <Row
                  name="Other Operating Gains"
                  key="Other Operating Gains"
                  total={data["Other Operating Gains"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Operating Profit"] !== undefined ? (
                <Row
                  name="Operating Profit"
                  key="Operating Profit"
                  total={data["Operating Profit"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {/* {data["Finance Income"] !== undefined ? (
              <Row
                name="Finance Income"
                key="Finance Income"
                total={data["Finance Income"]}
              />
            ) : (
              <></>
            )} */}
              {data["Net Foreign Exchange Gains"] !== undefined ? (
                <Row
                  name="Net Foreign Exchange Gains/Losses"
                  key="Net Foreign Exchange Gains"
                  total={data["Net Foreign Exchange Gains"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Fair Value Gain On Equity Investments"] !== undefined ? (
                <Row
                  name="Fair Value Gain On Equity Investments"
                  key="Fair Value Gain On Equity Investments"
                  total={data["Fair Value Gain On Equity Investments"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Fair Value Gain On Investment Property"] !== undefined ? (
                <Row
                  name="Fair Value Gain On Investment Property"
                  key="Fair Value Gain On Investment Property"
                  total={data["Fair Value Gain On Investment Property"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Gain On Disposal of Investment Property"] !== undefined ? (
                <Row
                  name="Gain On Disposal of Investment Property"
                  key="Gain On Disposal of Investment Property"
                  total={data["Gain On Disposal of Investment Property"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Impairment Loss"] !== undefined ? (
                <Row
                  name="Impairment Loss"
                  key="Impairment Loss"
                  total={data["Impairment Loss"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["EBITDA"] !== undefined ? (
                <Row
                  name="EBITDA"
                  key="EBITDA"
                  total={data["EBITDA"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Depreciation & Amortization (After OP)"] !== undefined ? (
                <Row
                  name="Depreciation & Amortization (After OP)"
                  key="Depreciation & Amortization (After OP)"
                  total={data["Depreciation & Amortization (After OP)"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["EBIT"] !== undefined ? (
                <Row
                  name="EBIT"
                  key="EBIT"
                  total={data["EBIT"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Compensating Tax"] !== undefined ? (
                <Row
                  name="Compensating Tax"
                  key="Compensating Tax"
                  total={data["Compensating Tax"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Finance Income"] !== undefined ? (
                <Row
                  name="Finance Income"
                  key="Finance Income"
                  total={data["Finance Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Provision For Expected Credit Losses"] !== undefined ? (
                <Row
                  name="Provision For Expected Credit Losses"
                  key="Provision For Expected Credit Losses"
                  total={data["Provision For Expected Credit Losses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Credit Impairment Losses"] !== undefined ? (
                <Row
                  name="Credit Impairment Losses"
                  key="Credit Impairment Losses"
                  total={data["Credit Impairment Losses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Net Allowance For Expected Credit Losses"] !== undefined ? (
                <Row
                  name="Net Allowance For Expected Credit Losses"
                  key="Net Allowance For Expected Credit Losses"
                  total={data["Net Allowance For Expected Credit Losses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}

              {data["Finance Costs"] !== undefined ? (
                <Row
                  name="Finance Costs"
                  key="Finance Costs"
                  total={data["Finance Costs"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Share Of Profit After Income Tax Of Associate"] !==
                undefined ? (
                <Row
                  name="Share Of Profit After Income Tax Of Associate"
                  key="Share Of Profit After Income Tax Of Associate"
                  total={data["Share Of Profit After Income Tax Of Associate"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Share Of Profit/Loss Of Associates"] !== undefined ? (
                <Row
                  name="Share Of Profit/Loss Of Associates"
                  key="Share Of Profit/Loss Of Associates"
                  total={data["Share Of Profit/Loss Of Associates"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Interest Expenses"] !== undefined ? (
                <Row
                  name="Interest Expenses"
                  key="Interest Expenses"
                  total={data["Interest Expenses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Other Losses"] !== undefined ? (
                <Row
                  name="Other Losses"
                  key="Other Losses"
                  total={data["Other Losses"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["PBT"] !== undefined ? (
                <Row
                  name="PBT"
                  key="PBT"
                  total={data["PBT"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Income Taxes"] !== undefined ? (
                <Row
                  name="Income Taxes"
                  key="Income Taxes"
                  total={data["Income Taxes"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
              {data["Net Income"] !== undefined ? (
                <Row
                  name="Net Income"
                  key="Net Income"
                  total={data["Net Income"]}
                  currency={data["currency"]}
                />
              ) : (
                <></>
              )}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </>
  );
}
